import { render, staticRenderFns } from "./PreSupportPromptMessage.vue?vue&type=template&id=23456d1a&scoped=true"
import script from "./PreSupportPromptMessage.vue?vue&type=script&lang=ts"
export * from "./PreSupportPromptMessage.vue?vue&type=script&lang=ts"
import style0 from "./PreSupportPromptMessage.vue?vue&type=style&index=0&id=23456d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23456d1a",
  null
  
)

export default component.exports